/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from 'react-router-dom';

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import SpendGrid from "./spendGrid";
import { useHotelReportsService } from '../../../../services/hotelReportsService';
import HotelBookingReportsFilters from '../hotelBookingReoprtFilters';

/* Styles */
import styles from "./styles.js"



const SpendReportTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/spend')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      reportType: "spend",
      gridName: "spendGrid",
      page: +initialPage,
      bookedStartDate: "",
      bookedEndDate: "",
      travelStartDate: "",
      travelEndDate: ""
    };
  });

  const { hotelReportsResponse, getHotelReportsList } = useHotelReportsService();

  const enableDownloadButton = hotelReportsResponse?.results?.dataItems.length > 0;


  useEffect(() => {
    getHotelReportsList(gridOptions);
    gridOptions.page > 1 ? navigate(`/app/reports/spend?page=${gridOptions.page}`) : navigate(`/app/reports/spend`)
  }, [gridOptions])

  const onRowClick = row => {}

  return (
    <div className={classes.spendTab}>
      <HotelBookingReportsFilters
        response={hotelReportsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        type="REPORTS"
        enableDownloadButton={enableDownloadButton}
      />
      <SpendGrid
        mileageResponse={hotelReportsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        onRowClick={onRowClick}
      />
    </div>
  )
}

export default SpendReportTab;
